import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import {MaterialModule} from "./material/material.module";
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import { CookieService } from 'ngx-cookie-service';
import {MAT_DATE_LOCALE} from "@angular/material/core";
import {ToastrModule} from "ngx-toastr";
import {HighchartsChartModule} from "highcharts-angular";
import {HttpClientModule} from "@angular/common/http";

import { PageDoesNotExistComponent } from './page-does-not-exist/page-does-not-exist.component';
import { AboutUsComponent } from './pages/about-us/about-us.component';
import { TermsOfUseComponent } from './terms-of-use/terms-of-use.component';
import { ContactComponent } from './pages/contact/contact.component';
import { PrivacyPolicyComponent } from './privacy-policy/privacy-policy.component';
import { HomeComponent } from './home/home.component';
import { BigDataComponent } from './pages/big-data/big-data.component';
import { HurtownieDanychComponent } from './pages/hurtownie-danych/hurtownie-danych.component';
import { OptymalizacjaSystemowComponent } from './pages/optymalizacja-systemow/optymalizacja-systemow.component';
import { BezpieczenstwoComponent } from './pages/bezpieczenstwo/bezpieczenstwo.component';
import { RozwiazaniaDuzejDostepnosciComponent } from './pages/rozwiazania-duzej-dostepnosci/rozwiazania-duzej-dostepnosci.component';
import { LanguagePipe } from './language/language.pipe';
import {LanguageService} from "./language/language.service";
import { RodoComponent } from './rodo/rodo.component';


@NgModule({
  declarations: [
    AppComponent,
    PageDoesNotExistComponent,
    AboutUsComponent,
    TermsOfUseComponent,
    ContactComponent,
    PrivacyPolicyComponent,
    HomeComponent,
    BigDataComponent,
    HurtownieDanychComponent,
    OptymalizacjaSystemowComponent,
    BezpieczenstwoComponent,
    RozwiazaniaDuzejDostepnosciComponent,
    RodoComponent,
    LanguagePipe
  ],
 imports: [
  BrowserModule,
  FormsModule,
  HttpClientModule,
  AppRoutingModule,
  BrowserAnimationsModule,
  ReactiveFormsModule,
  MaterialModule,
  ToastrModule.forRoot(),
  HighchartsChartModule
 ],
  providers: [CookieService, { provide: MAT_DATE_LOCALE, useValue: 'en-GB' }, LanguagePipe, LanguageService],
  bootstrap: [AppComponent]
})
export class AppModule { }

